/**
 * @generated SignedSource<<080192960e061f89098b18bf83162403>>
 * @relayHash 74050166d454b6d9ce9f7ed4035511fc
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 33f5ecab3cdc817eb5f9adab300a034ff8d925bd997f473939a440277277f204

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type L1MenuItemsQuery$variables = {
  cloudId: string;
  isAppsExpanded?: boolean | null | undefined;
  isPlansExpanded?: boolean | null | undefined;
  isProjectsExpanded?: boolean | null | undefined;
};
export type L1MenuItemsQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"ConfigurableMenu">;
};
export type L1MenuItemsQuery = {
  response: L1MenuItemsQuery$data;
  variables: L1MenuItemsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "isAppsExpanded"
},
v2 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "isPlansExpanded"
},
v3 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "isProjectsExpanded"
},
v4 = {
  "kind": "ScalarField",
  "name": "id"
},
v5 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v6 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v7 = {
  "kind": "InlineFragment",
  "selections": [
    (v4/*: any*/)
  ],
  "type": "Node",
  "abstractKey": "__isNode"
},
v8 = [
  {
    "kind": "LinkedField",
    "name": "node",
    "plural": false,
    "selections": [
      (v6/*: any*/),
      {
        "kind": "InlineFragment",
        "selections": [
          (v4/*: any*/),
          {
            "alias": "projectKey",
            "kind": "ScalarField",
            "name": "key"
          },
          {
            "concreteType": "JiraAvatar",
            "kind": "LinkedField",
            "name": "avatar",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "small"
              }
            ]
          },
          {
            "kind": "ScalarField",
            "name": "name"
          },
          {
            "kind": "ScalarField",
            "name": "projectType"
          },
          {
            "kind": "LinkedField",
            "name": "navigationMetadata",
            "plural": false,
            "selections": [
              (v6/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "boardId"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "isSimpleBoard"
                  },
                  (v4/*: any*/)
                ],
                "type": "JiraSoftwareProjectNavigationMetadata"
              }
            ]
          },
          {
            "kind": "ScalarField",
            "name": "isFavourite"
          },
          {
            "kind": "ScalarField",
            "name": "projectStyle"
          },
          {
            "kind": "ScalarField",
            "name": "projectUrl"
          },
          {
            "args": [
              {
                "kind": "Literal",
                "name": "type",
                "value": "EDIT_PROJECT_CONFIG"
              }
            ],
            "concreteType": "JiraProjectAction",
            "kind": "LinkedField",
            "name": "action",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "canPerform"
              }
            ],
            "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
          }
        ],
        "type": "JiraProject"
      },
      (v7/*: any*/)
    ]
  }
],
v9 = {
  "kind": "ScalarField",
  "name": "label"
},
v10 = {
  "kind": "ScalarField",
  "name": "url"
},
v11 = {
  "kind": "ScalarField",
  "name": "iconUrl"
},
v12 = {
  "kind": "ScalarField",
  "name": "styleClass"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "name": "L1MenuItemsQuery",
    "selections": [
      {
        "kind": "FragmentSpread",
        "name": "ConfigurableMenu"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v3/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "L1MenuItemsQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": [
              {
                "kind": "Variable",
                "name": "cloudID",
                "variableName": "cloudId"
              },
              {
                "kind": "Literal",
                "name": "navKey",
                "value": "NAV_SIDEBAR"
              }
            ],
            "concreteType": "JiraUserNavigationConfiguration",
            "kind": "LinkedField",
            "name": "userNavigationConfiguration",
            "plural": false,
            "selections": [
              {
                "concreteType": "JiraConfigurableNavigationItem",
                "kind": "LinkedField",
                "name": "navItems",
                "plural": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "menuId"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "isVisible"
                  }
                ]
              },
              (v4/*: any*/)
            ]
          }
        ]
      },
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "condition": "isProjectsExpanded",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "args": [
                  (v5/*: any*/),
                  {
                    "kind": "Literal",
                    "name": "filter",
                    "value": {
                      "type": "PROJECT"
                    }
                  },
                  {
                    "kind": "Literal",
                    "name": "first",
                    "value": 15
                  }
                ],
                "concreteType": "JiraFavouriteConnection",
                "kind": "LinkedField",
                "name": "favourites",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "hasNextPage"
                      }
                    ]
                  },
                  {
                    "concreteType": "JiraFavouriteEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": (v8/*: any*/)
                  }
                ]
              },
              {
                "args": [
                  (v5/*: any*/),
                  {
                    "kind": "Literal",
                    "name": "first",
                    "value": 20
                  },
                  {
                    "kind": "Literal",
                    "name": "types",
                    "value": [
                      "PROJECT"
                    ]
                  }
                ],
                "concreteType": "JiraSearchableEntityConnection",
                "kind": "LinkedField",
                "name": "recentItems",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraSearchableEntityEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": (v8/*: any*/)
                  }
                ]
              }
            ]
          },
          {
            "alias": "canCreateProject",
            "args": [
              (v5/*: any*/),
              {
                "kind": "Literal",
                "name": "type",
                "value": "CREATE_PROJECT"
              }
            ],
            "kind": "ScalarField",
            "name": "canPerform"
          },
          {
            "condition": "isAppsExpanded",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "args": [
                  {
                    "kind": "Literal",
                    "name": "boardId",
                    "value": "ari:cloud:jira-software:1ea8bfb6-3dc1-48bb-9045-73a412f2941c:board/85"
                  },
                  {
                    "kind": "Literal",
                    "name": "projectIdOrKey",
                    "value": "CS"
                  }
                ],
                "concreteType": "JiraNavigationItemConnection",
                "kind": "LinkedField",
                "name": "jiraSoftwareNavigationItems",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraNavigationItemEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v6/*: any*/),
                          (v4/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v9/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "appType"
                              },
                              (v10/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "appId"
                              },
                              (v11/*: any*/),
                              (v12/*: any*/),
                              {
                                "concreteType": "JiraAppSection",
                                "kind": "LinkedField",
                                "name": "sections",
                                "plural": true,
                                "selections": [
                                  (v9/*: any*/),
                                  {
                                    "concreteType": "JiraAppNavigationItemNestedLink",
                                    "kind": "LinkedField",
                                    "name": "links",
                                    "plural": true,
                                    "selections": [
                                      (v9/*: any*/),
                                      (v10/*: any*/),
                                      (v11/*: any*/),
                                      (v12/*: any*/)
                                    ]
                                  }
                                ]
                              },
                              {
                                "kind": "ScalarField",
                                "name": "envLabel"
                              }
                            ],
                            "type": "JiraAppNavigationItem"
                          }
                        ]
                      }
                    ]
                  }
                ],
                "storageKey": "jiraSoftwareNavigationItems(boardId:\"ari:cloud:jira-software:1ea8bfb6-3dc1-48bb-9045-73a412f2941c:board/85\",projectIdOrKey:\"CS\")"
              }
            ]
          }
        ]
      },
      {
        "condition": "isPlansExpanded",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "concreteType": "JiraQuery",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
              {
                "alias": "planFavourites",
                "args": [
                  (v5/*: any*/),
                  {
                    "kind": "Literal",
                    "name": "filter",
                    "value": {
                      "type": "PLAN"
                    }
                  },
                  {
                    "kind": "Literal",
                    "name": "first",
                    "value": 10
                  }
                ],
                "concreteType": "JiraFavouriteConnection",
                "kind": "LinkedField",
                "name": "favourites",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraFavouriteEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v6/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v4/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "planId"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "title"
                              }
                            ],
                            "type": "JiraPlan"
                          },
                          (v7/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "33f5ecab3cdc817eb5f9adab300a034ff8d925bd997f473939a440277277f204",
    "metadata": {},
    "name": "L1MenuItemsQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "53e41716e008b4db9fa63e32f653d4bd";

export default node;
